/**
 * Class that describes the grouping of controls in a form
 */
export class DescriptorFormGroup {

    /**
     * The group name
     */
    name: string = '';

    /**
     * The controls keys which belong to the group
     */
    ids: string[] = [];
}